import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { StatusPanel } from "./components/StatusPanel";
import { RegisterSection } from "./components/RegisterSection";
import { ClientGuides } from "./components/ClientGuides";
import { Faq, Footer } from "./components/Faq";
import { useServerStatus } from "./hooks/useServerStatus";
import { I18nProvider } from "./lib/i18n";
import { useTheme } from "./lib/theme";
import { RetroSite } from "./components/retro/RetroSite";

function App() {
  return (
    <I18nProvider>
      <Site />
    </I18nProvider>
  );
}

function Site() {
  const { status, stats, loading, refresh } = useServerStatus();
  const [theme, setTheme] = useTheme();
  if (theme === "retro") {
    return (
      <>
        <RetroSite status={status} stats={stats} loading={loading} refresh={refresh} setTheme={setTheme} />
        <Toaster theme="light" position="bottom-right" offset={56} />
      </>
    );
  }
  return (
    <div className="grain min-h-screen bg-[#0D1117] text-[#F0F6FC]">
      <Navbar status={status} onRetro={() => setTheme("retro")} />
      <main className="relative z-10">
        <Hero status={status} />
        <StatusPanel status={status} stats={stats} loading={loading} refresh={refresh} />
        <RegisterSection onRegistered={refresh} />
        <ClientGuides />
        <Faq />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
